// utils
import * as methods from '@utils/methods';

import { DELETE, GET, POST, PUT } from '../request';

/**
 * fetch internalmed list
 * @param {*} payload
 */
export async function fetchInternalmedList(payload) {
  const params = methods.convertQueryString(payload);
  return GET(`internalmed?${params}`);
}

/**
 * get internalmed
 * @param {*} payload
 */

export async function fetchInternalmed(payload) {
  return GET(`internalmed/${payload}`);
}

/**
 * update internalmed by id
 * @param {*} payload
 */
export async function updateInternalmedById(payload) {
  const { id, ...rest } = payload;
  return PUT(`internalmed/${id}`, rest);
}

/**
 * remove internalmed by id
 * @param {*} payload
 */
export async function removeInternalmedById(payload) {
  return DELETE(`internalmed/${payload}`);
}

/**
 * create internalmed
 * @param {*} payload
 */
export async function createInternalmed(payload) {
  return POST(`internalmed`, payload);
}
